export enum PlaceType {
  ROOM = 'ROOM',
  CITY = 'CITY',
  FOREST = 'FOREST',
}

export enum Orientation {
  N = 'N',
  S = 'S',
  E = 'E',
  W = 'W',
  NE = 'NE',
  SE = 'SE',
  SW = 'SW',
  NW = 'NW',
  UP = 'UP',
  DOWN = 'DOWN',
}
